import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const guidesData = [
  { number: '1', principle: 'Ahimsa' },
  { number: '2', principle: 'Santosha' },
  { number: '3', principle: 'Pratyahara' },
  { number: '4', principle: 'Svadhyaya' },
  { number: '5', principle: 'Aparigraha' },
  { number: '6', principle: 'Tapas' },
  { number: '7', principle: 'Pranayama' },
  { number: '8', principle: 'Ahimsa' },
];

const heroImage = 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/39ae2465-4921-439d-b41b-f8e038112446_compressed_ChatGPT-Image-10-ago-2026-01_32_48-a.m..webp';

export default function FundamentosSueno() {
  const { t, i18n } = useTranslation();
  const [hoveredGuide, setHoveredGuide] = useState<number | null>(null);

  // Checkout de Hotmart segun el idioma de la pagina
  const checkoutUrl =
    i18n.language === 'en'
      ? 'https://pay.hotmart.com/P107839671E'
      : 'https://pay.hotmart.com/V107838208W';

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      <div className="fixed top-0 left-0 w-full h-1 z-50">
        <div
          className="h-full bg-terracotta transition-all duration-150"
          style={{ width: '0%' }}
          id="reading-progress"
        />
      </div>

      <section className="relative pt-28 md:pt-36 pb-12 md:pb-20 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start mb-10 md:mb-16">
            <div className="w-full md:w-1/2">
              <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
                {t('fundamentos.tag')}
              </span>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-[#8B6F5C] leading-tight">
                {t('fundamentos.title1')}
                <br />
                <span className="font-bold">{t('fundamentos.title2')}</span>
              </h1>
            </div>
            <div className="w-full md:w-1/2 flex flex-col justify-end md:pt-12">
              <p className="font-sans text-base md:text-lg text-[#3D2B1F] leading-relaxed mb-6">
                {t('fundamentos.hero.desc')}
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-user-smile-line text-xs" />
                  {t('fundamentos.badge1')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-calendar-line text-xs" />
                  {t('fundamentos.badge2')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-file-text-line text-xs" />
                  {t('fundamentos.badge3')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-infinity-line text-xs" />
                  {t('common.acceso_de_por_vida')}
                </span>
              </div>
              <div className="flex items-baseline gap-3 mb-6">
                <span className="font-serif text-4xl md:text-5xl font-bold text-[#8B6F5C]">$27</span>
                <span className="font-sans text-sm text-[#5C4A3A]">{t('common.usd')} — {t('common.pago_unico')}</span>
              </div>
              <a
                href={checkoutUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-terracotta text-white px-8 py-3.5 rounded-full font-sans text-sm font-semibold hover:bg-brown transition-colors duration-300 w-fit cursor-pointer"
              >
                {t('common.comprar_usd')}
                <i className="ri-shopping-cart-line" />
              </a>
            </div>
          </div>
          <div className="w-full h-[320px] md:h-[420px] rounded-3xl overflow-hidden">
            <img
              src={heroImage}
              alt={t('fundamentos.title1') + ' ' + t('fundamentos.title2')}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-heart-line text-3xl text-cream" />
          </div>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-cream leading-tight mb-8">
            {t('fundamentos.emotional.title')}
          </h2>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            {t('fundamentos.emotional.p1')}
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            {t('fundamentos.emotional.p2')}
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed">
            {t('fundamentos.emotional.p3')}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
              {t('fundamentos.guias_tag')}
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
              {t('fundamentos.guias_title')}
            </h2>
            <p className="font-sans text-base text-[#3D2B1F] max-w-2xl mx-auto">
              {t('fundamentos.guias_desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {guidesData.map((guide, index) => (
              <div
                key={guide.number}
                className="bg-white rounded-2xl p-6 md:p-8 border border-sand/40 transition-all duration-300 hover:border-terracotta/30"
                onMouseEnter={() => setHoveredGuide(index)}
                onMouseLeave={() => setHoveredGuide(null)}
              >
                <div className="flex items-start gap-4 md:gap-6">
                  <div className="flex-shrink-0">
                    <span className="font-serif text-4xl md:text-5xl font-light text-[#5C4A3A] leading-none">
                      {guide.number}
                    </span>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-serif text-xl md:text-2xl font-bold text-[#8B6F5C] mb-3 leading-tight">
                      {t(`fundamentos.guias.items.${guide.number}.title`)}
                    </h3>
                    <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed mb-4">
                      {t(`fundamentos.guias.items.${guide.number}.description`)}
                    </p>
                    <div className="bg-[#F7F2EA] rounded-xl p-4 border border-sand/20">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="font-sans text-xs font-bold text-terracotta uppercase tracking-wider">
                          {t('fundamentos.principio')} {guide.principle}
                        </span>
                      </div>
                      <p className="font-sans text-sm text-[#5C4A3A] leading-relaxed italic">
                        &ldquo;{t(`fundamentos.guias.items.${guide.number}.principleText`)}&rdquo;
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center">
            <div className="w-full md:w-1/2">
              <div className="w-14 h-14 rounded-2xl bg-[#AAB7A3]/20 flex items-center justify-center mb-6">
                <i className="ri-mind-map text-2xl text-[#AAB7A3]" />
              </div>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#8B6F5C] leading-tight mb-6">
                {t('fundamentos.bridge.title')}
                <br />
                <span className="font-bold">{t('fundamentos.bridge.title2')}</span>
              </h2>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                {t('fundamentos.bridge.p1')}
              </p>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                {t('fundamentos.bridge.p2')}
              </p>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed">
                {t('fundamentos.bridge.p3')}
              </p>
            </div>
            <div className="w-full md:w-1/2">
              <div className="bg-cream rounded-3xl p-8 md:p-10 border border-sand/30">
                <h3 className="font-serif text-2xl font-bold text-[#8B6F5C] mb-6">
                  {t('fundamentos.que_incluye')}
                </h3>
                <ul className="flex flex-col gap-4">
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
                    <li key={num} className="flex items-center gap-3">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#AAB7A3]/20 flex-shrink-0">
                        <i className="ri-check-line text-[#AAB7A3] text-sm" />
                      </div>
                      <span className="font-sans text-sm text-[#3D2B1F]">{t(`fundamentos.incluye.${num}`)}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-eye-off-line text-3xl text-cream" />
          </div>
          <p className="font-serif text-2xl md:text-3xl text-cream leading-relaxed mb-8">
            {t('fundamentos.quote')}
          </p>
          <div className="w-16 h-px bg-cream/30 mx-auto mb-8" />
          <p className="font-sans text-base text-cream/80 leading-relaxed">
            {t('fundamentos.quote_author')}
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
            {t('fundamentos.cta.title')}
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] max-w-xl mx-auto mb-8">
            {t('fundamentos.cta.desc')}
          </p>
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="font-serif text-5xl md:text-6xl font-bold text-[#8B6F5C]">$27</span>
            <span className="font-sans text-base text-[#5C4A3A]">{t('common.usd')}</span>
          </div>
          <a
            href={checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-terracotta text-white px-10 py-4 rounded-full font-sans text-base font-semibold hover:bg-brown transition-colors duration-300 mb-4 cursor-pointer"
          >
            {t('common.comprar_usd')}
            <i className="ri-shopping-cart-line" />
          </a>
          <p className="font-sans text-sm text-[#5C4A3A]">
            {t('fundamentos.cta.footer')}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}